"use client";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import GalleryImg1 from '../../assets/images/gallery/gallery-1-1.jpg'
import GalleryImg2 from '../../assets/images/gallery/gallery-1-2.jpg'
import GalleryImg3 from '../../assets/images/gallery/gallery-1-3.jpg'
import GalleryImg4 from '../../assets/images/gallery/gallery-1-4.jpg'
import GalleryImg5 from '../../assets/images/gallery/gallery-1-5.jpg'
import GalleryImg6 from '../../assets/images/gallery/gallery-1-6.jpg'
import GalleryImg7 from '../../assets/images/gallery/gallery-1-7.jpg'
import GalleryImg8 from '../../assets/images/gallery/gallery-1-9.jpg'
import { getGallery } from "../../services/settingsService";
import imgPlaceholder from "../../assets/images/resources/img-placeholder.svg";

// Admin panel থেকে এখনো কোনো ছবি add করা না থাকলে এই default template
// ছবিগুলো দেখানো হয়, যাতে পেজটা কখনো খালি না দেখায়।
const fallbackItems = [
  { image: GalleryImg1, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg2, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg3, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg4, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg5, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg6, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg7, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
  { image: GalleryImg8, title: "Dream Makers Event Planning", subtitle: "Gala Affairs" },
];

export default function Home() {
  const [items, setItems] = useState(fallbackItems);

  useEffect(() => {
    getGallery()
      .then((data) => {
        if (data.items && data.items.length > 0) {
          setItems(data.items);
        }
      })
      .catch(() => {
        // fetch ব্যর্থ হলেও fallback ছবিগুলোই থেকে যাবে, পেজ ভাঙবে না
      });
  }, []);

  return (

          <section className="gallery-one">
            <div className="container">
              <div className="row masonary-layout">
                {items.map((item, index) => (
                  <div
                    key={item.id ?? index}
                    className="col-xl-3 col-lg-6 col-md-6"
                  >
                    <div className="gallery-one__single">
                      <div className="gallery-one__img">
                        <img
                          src={item.image || imgPlaceholder}
                          alt={item.title || "Gallery"}
                          onError={(e) => { e.target.onerror = null; e.target.src = imgPlaceholder; }}
                        />
                        <div className="gallery-one__content">
                          <div className="gallery-one__sub-title-box">
                            <div className="gallery-one__sub-title-shape"></div>
                            <p className="gallery-one__sub-title">
                              {item.subtitle}
                            </p>
                          </div>
                          <h4 className="gallery-one__title">
                            <Link to="/gallery-details">{item.title}</Link>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>


  );
}
